module.exports = __webpack_public_path__ + "img/avatar-17.fc7774ad.png";